let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1t0CA")).then(() => parcelRequire('gdZr0'));